import { validatorTypes } from '@data-driven-forms/react-form-renderer';
import moment from 'moment';

//fathersname, dob, gender,pan number, tshirt size
const zomatoPersonalInfoSchema = {
    fields: [
        {
            component: 'radio',
            label: 'Gender',
            name: 'gender',
            options: [
              {
                label: 'Male',
                value: 'male',
              },
              {
                label: 'Female',
                value: 'female',
              },
              {
                label: 'Other',
                value: 'other',
              },
            ],
            isRequired: true,
            validate: [
              {
                type: 'required',
              },
            ],
          },
          {
            component: 'date-picker',
            label: 'Date Of Birth',
            name: 'dateOfBirth',
            isRequired: true,
            inputReadOnly: true,
            validate: [
              {
                type: 'required',
              },
            ],
          },
          {
            component: 'text-field',
            name: 'fathersName',
            label: `Father's Name`,
            isRequired: true,
            validate: [
              {
                type: 'required',
              },
            ],
            placeholder: 'Enter your father name',
          },
          {
            component: 'text-field',
            name: 'panNumber',
            label: 'PAN Card Number',
            isRequired: true,
            validate: [
              {
                type: 'required',
              },
              {
                type: validatorTypes.PATTERN,
                pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                message: 'PAN card format is incorrect',
              },
            ],
            placeholder: 'Enter your PAN card Number',
          },
          {
            "component": "select",
            "label": "Select T-Shirt Size",
            "placeholder": 'Please choose a t-shirt size',
            "name": "zomatoTShirtSize",
            "simpleValue": true,
            isRequired: true,
            validate: [
              {
                type: 'required',
              }
            ],
            "options": [
              {
                "label": "S (39 inches)",
                "value": "S"
              },
              {
                "label": "M (41 inches)",
                "value": "M"
              },
              {
                "label": "L (43 inches)",
                "value": "L"
              },
              {
                "label": "XL (45 inches)",
                "value": "XL"
              },
              {
                "label": "2XL (47 inches)",
                "value": "2XL"
              }
            ]
            
          }
    ]
};

export default zomatoPersonalInfoSchema;
